export const AdvantageRedirectRoute: string = "advantage-redirect";